import { InputNumber } from 'antd';
import Styles from './index.module.scss';

interface IProps {
  suffix: string;
  onChange?: Function;
  [index: string]: any;
}

const NumberInput = ({ suffix, onChange, ...props }: IProps) => {
  const inputChange = (val) => {
    onChange(val);
  };

  return (
    <span style={{}}>
      <InputNumber
        controls={false}
        size="middle"
        className={Styles.numberInput}
        onChange={inputChange}
        {...props}
      />
      {suffix && <span className={Styles.numberInputSuffix}>{suffix}</span>}
    </span>
  );
};

export default NumberInput;
